/**
 * Marketo audience integration
 * @module
 */

// TODO(jon): This whole module could be generalized for any server-side audience integration like Marketo or
//            Salesforce, just requiring the vendor string ('marketo', 'salesforce', etc.) and field names ('list',
//            'report', etc).
var VENDOR = 'marketo';

var MARKETO_STATIC_LIST_FIELD_NAME = 'list';

var matcher = {
  fieldsNeeded: ['lists'],

  match: function(value, cond) {
    if (cond.name !== MARKETO_STATIC_LIST_FIELD_NAME) {
      throw new Error('Unrecognized Marketo condition name "' + cond.name + '" provided');
    }

    var listNamesToMembership = value.lists;

    // Optimizely uploaded audiences with the "_marketo__list__" prefix indicate the visitor's membership in a
    // Marketo static list (https://docs.marketo.com/display/public/DOCS/Understanding+Static+Lists).
    var matchingListName = '_' + VENDOR + '__' + MARKETO_STATIC_LIST_FIELD_NAME + '__' + cond.value;

    return !!listNamesToMembership[matchingListName];
  }
};

module.exports = function(PluginManager) {
  PluginManager.registerAudienceMatcher('vendor.' + VENDOR, matcher);
};

if (__TEST__) {
  module.exports.matcher = matcher;
}
